// extracted by mini-css-extract-plugin
export default {"btn_add_clear":"ModalAddSubaccounts_btn_add_clear__eGApA","errorText":"ModalAddSubaccounts_errorText__Z1NoY"};